import type {Section as MenuSection} from 'common/components/items-menu/types';

import {ExtraPanelAction} from '../panel/types';
import {ScrollPosition} from './constants';

export interface SidenavAttrs {
  selected?: string;
  loading?: boolean;
  'min-adjacent-width'?: number;
  header?: SidenavHeader;
  footer?: SidenavFooter;
  'user-id'?: number;
  'storage-key'?: string;
  'fixed-size'?: boolean;
}

export interface SidenavState {
  activeDragSectionIdx: number | null;
  collapsedSectionSet: Set<string>;
  hoveredItemValues: Set<string>;
  isCollapsed: boolean;
  isOverflowMenuOpen: boolean;
  scrollPosition: ScrollPosition;
  selectedItem: SidenavSectionItem | null;
  selectedSectionIndex: number | null;
  scrolledIntoItem: string;
  sections: SidenavSection[];
}

type SidenavCtaHeader = {title?: string; actions: SidenavCta[]};

type SidenavSlotHeader = {title?: string; slot: string; collapsedSlot?: string};

export type SidenavHeader = SidenavCtaHeader | SidenavSlotHeader;
export type SidenavFooter = {
  actions: ExtraPanelAction[];
};

export type SidenavSection = {
  label?: string;
  items: SidenavSectionItem[];
  emptyNotice?: string;
  dragDropEnabled?: boolean;
  isCollapsible: boolean;
};

export type SidenavSectionItem = {
  label: string;
  value: string;
  tooltip?: string;
  userName?: string;
  userId?: number;
  userEmail?: string;

  href?: string;
  target?: string;

  overflowMenuSections?: MenuSection[];

  isNew?: boolean;

  [key: string]: any;
};

export enum CtaIconTheme {
  Light = `light`,
  Dark = `dark`,
  Primary = `primary`,
}

export type SidenavCta = SidenavSectionItem & {
  icon: string;
  iconTheme?: CtaIconTheme;
};

export type PersistedSidenavState = {collapsedSectionSet: string[]};
export type ParsedPersistedSidenavState = Pick<SidenavState, 'collapsedSectionSet'>;
